import { ActivityIcon, BookOpenIcon, ClipboardCheckIcon, DraftingCompassIcon, PaletteIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Fiber Loss Budget & OTDR Trace Quick-Reference Cards',
    icon: ActivityIcon,
  },
  {
    number: '2',
    title: 'Fiber Color Codes, Connectors & Cable Identification Cheat Sheets',
    icon: PaletteIcon,
  },
  {
    number: '3',
    title: 'Field Installation & Inspection Checklists for Fiber, Cabling & Cell Sites',
    icon: ClipboardCheckIcon,
  },
  {
    number: '4',
    title: 'How to Read Network Drawings, Splice Diagrams & As-Built Records',
    icon: DraftingCompassIcon,
  },
  {
    number: '5',
    title: 'Telecommunications & Fiber Optic Terminology Dictionary',
    icon: BookOpenIcon,
  },
];
